import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"
import * as bootstrap from "bootstrap"

// Lifecycle for the pass-export toasts.
//
// Auto-hide: Bootstrap only reads `data-bs-autohide`/`data-bs-delay` when a
// Toast instance is built, and its timer starts on show(). These toasts are
// server-rendered as `.toast.show` (and broadcast that way over Turbo Streams),
// so they never get an instance and need this timer.
//
// Dismissal is persisted: the layout re-renders every active export on each
// page load, so hiding the toast client-side only would bring it back on the
// next reload. Every way of closing it routes through `dismiss()` rather than
// Bootstrap's own `data-bs-dismiss`, whose `hidden.bs.toast` event did not
// reliably reach listeners here.
export default class extends Controller {
  static values = { delay: Number, dismissUrl: String }

  connect() {
    if (this.delayValue > 0) {
      this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  // Closing is permanent — the export stays available under Descargas.
  dismiss() {
    clearTimeout(this.timeout)
    bootstrap.Toast.getOrCreateInstance(this.element, { autohide: false }).hide()

    if (this.dismissed || !this.hasDismissUrlValue) return
    this.dismissed = true
    patch(this.dismissUrlValue)
  }
}
